export default "__VITE_ASSET__332eedc2__"